/** The URL names the intended shop; authentication still comes from cookies.
 * A router basename retains the binding across navigation and hard reloads.
 * Legacy root URLs carry no additional context or headers.
 */
export function chatLevelContext(pathname = window.location.pathname) {
  const match = pathname.match(/^\/chatlevel\/([a-z0-9](?:[a-z0-9-]{1,38}[a-z0-9])?)(?:\/|$)/);
  return match ? { slug: match[1], basename: `/chatlevel/${match[1]}` } : null;
}

export function inventoryContextHeaders(): Record<string, string> {
  const context = chatLevelContext();
  return context ? { 'X-Inventory-Tenant': context.slug } : {};
}
